import { useCallback, useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { unwrapResult } from "@reduxjs/toolkit";
import { useParams, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import ReactGA from 'react-ga4';

import Title from "../../../uiKit/Title/Title";
import CustomButton from "../../../uiKit/Button/CustomButton";
import AnimatedLoading from "../../../uiKit/Loading/animatedLoading";
import { BluePen } from "../../../uiKit/assets/svg/icons";
import { Breadcrumb } from "../../../components/Breadcrumbs/breadcrumbs";

import { getCommunity, setImageURL, setTabType } from "../../../redux/state/communitySlice";
import { addMember } from "../../../redux/state/memberSlice";

const CommunityInfo = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { communityId } = useParams();

    const community = useSelector(state => state.community.community, shallowEqual);
    const screenWidth = useSelector(state => state.common.screenWidth, shallowEqual);
    const imageURL = useSelector(state => state.community.communityImageURL, shallowEqual);
    const isLoading = useSelector(state => state.community.isLoading.common, shallowEqual);

    const createCampaignHandler = useCallback(() => {
        ReactGA.event('create_campaign');
        history.push('/campaigns/create-campaign')
    }, [history])

    const suggestCampaignHandler = useCallback(() => {
        ReactGA.event('suggest_campaign_click');
        history.push('/campaigns/suggest-campaign')
    }, [history])

    const joinCommunityHandler = useCallback(() => {
        if (!!community.id) {
            dispatch(addMember(community.id))
                .then(unwrapResult)
                .then(() => history.push(`/communities/my`))
                .catch(({ title }) => toast.info(title))
        }
    }, [community.id, dispatch, history])

    useEffect(() => {
        ReactGA.send({ hitType: 'pageview', page: `/community` })
    }, [])

    useEffect(() => {
        if (!communityId) return;
        dispatch(getCommunity(communityId))
            .then(unwrapResult)
            .then(response => {
                const { community } = response;
                const { images } = community;
                if (screenWidth < 900) {
                    dispatch(setImageURL(images.mobile));
                }
                else {
                    dispatch(setImageURL(images.desktop));
                }
            })
    }, [dispatch, screenWidth, communityId])

    const displayCommunityAdminsHandler = () => {
        dispatch(setTabType(5));
        window.scrollTo(0, document.body.scrollHeight);
    }

    const navigateToEditHandler = () => history.push(`/communities/community/${communityId}/edit`)

    return (
        <>
            <Breadcrumb />
            <div
                className='communityInfoHeaderWrapper'
                style={{ position: 'relative' }}
            >
                <div className='campaignMobileHeader'>
                    <div className='photoWrapper' style={{ backgroundImage: `url(${imageURL})` }} />
                    <div className="ourBalanceTitle" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Title text={community.name}
                            fontSize={screenWidth < 1200 ? 24 : 32}
                            lineHeight={screenWidth < 1200 ? 32 : 40}

                        />
                        {!!community.role && <CustomButton
                            isWhite
                            title={"Edit"}
                            Icon={BluePen}
                            onClick={navigateToEditHandler}
                        />}
                    </div>
                    {
                        !!community.description && (
                            <Title text={community.description}
                                fontSize={14}
                                lineHeight={20}
                                fontWeight={400}
                                style={{ marginBottom: '16px' }}
                            />
                        )
                    }
                    <AnimatedLoading loading={isLoading} />
                </div>
                {
                    !!community.role ? (
                        <CustomButton
                            title='New Campaign'
                            classNames='maxContentButton'
                            onClick={createCampaignHandler}
                        />
                    ) : (
                        <div className='memberButtons' style={{ gap: '16px' }}>
                            <CustomButton
                                title='Suggest Campaign'
                                isWhite
                                onClick={suggestCampaignHandler}
                            />
                            <CustomButton
                                title='Contact Community Admin'
                                isWhite
                                onClick={displayCommunityAdminsHandler}
                            />
                            {community?.role === null && <CustomButton
                                title='Join'
                                onClick={joinCommunityHandler}
                            />}
                        </div>
                    )
                }
            </div>
        </>
    )
}

export default CommunityInfo;